<section class="mission-area ptb-100 jarallax" data-jarallax='{"speed": 0.3}'>
  <div class="container">
    <div class="mission-content">
      <div class="section-title text-left">
        <span class="sub-title">SECOM</span>
        <h2>Портал ОНЛАЙН курсов и пробных тестов</h2>
      </div>

      <div class="mission-slides owl-carousel owl-theme">
        <div>
          <h3>Онлайн курсы и пробные тесты. Теперь</h3>
          <p>1. Пройти регистрацию на сайте </p>
          <p>2. Оплатить у нас в офисе или онлайн через систему ЭЛСОМ(код агента:11720)</p>
          <p>3. Обратиться к администрации за доступом </p>
          <a class="default-btn" routerLink="/contacts"><i class='bx bx-user-pin icon-arrow before'></i> <span
            class="label">Открыть</span><i class="bx bx-user-pin icon-arrow after"></i></a>
        </div>

        <div>
          <h3>Удобно и доступно для каждого</h3>
          <p>В целях эффективной подготовки к ОРТ мы разработали для наших учащихся онлайн курсы, тесты. теперь вы
            можете подготовиться в удобном формате</p>
          <p>Наши курсы были разработаны нашими учителями с многолетним опытом.</p>
          <a class="default-btn" routerLink="/courses"><i class='bx bx-user-pin icon-arrow before'></i> <span
            class="label">Открыть</span><i class="bx bx-user-pin icon-arrow after"></i></a>
        </div>
      </div>
    </div>
  </div>
</section>
